import { PeopleAlt } from "@mui/icons-material";
import ElectricMeterIcon from "@mui/icons-material/ElectricMeter";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { NavUser, Utility } from "utils/asset";

const Icon = ({ src, alt }) => <LazyLoadImage src={src} alt={alt} width="16" />;

// ==============================|| MENU ITEMS - PAGES ||============================== //

const utilityPages = {
  id: "utility-group-pages",
  title: <FormattedMessage id="utility pages" />,
  type: "group",
  children: [
    // {
    //   id: "utility",
    //   title: <FormattedMessage id="Utility" />,
    //   type: "item",
    //   url: "/utility",
    //   icon: () => <Icon src={Utility} alt="utility icon" />,
    //   subject: "Utility",
    // },
    // {
    //   id: "utility-reading",
    //   title: "Utility Reading",
    //   type: "item",
    //   url: "/utility-reading",
    //   icon: () => <ElectricMeterIcon sx={{ fontSize: 16, color: "inherit" }} />,
    //   subject: "UtilityReading",
    // },
    {
      id: "utility-record",
      title: "Utility Record",
      type: "item",
      url: "/utility-record",
      icon: () => <ReceiptLongIcon sx={{ fontSize: 16, color: "inherit" }} />,
      subject: "UtilityRecord",
    },
  ],
};

export default utilityPages;
